<form [formGroup]="form">
  <new-multipass-subscription-video
    *ngIf="videoModalVisible"
    (close)="videoModalVisible = false"></new-multipass-subscription-video>
  <div class="p-3">
    <!-- COMPONENT HEADER START -->
    <div class="row d-flex align-items-center mb-2">
      <div class="col-sm-4" *ngIf="contentTypesEnabled">
        <div dropdown>
          <div dropdownToggle class="editable-field">
            <button
              class="bg-white btn btn-outline-muted btn-block d-flex justify-content-between align-items-center">
              <span>{{
                selectedContentType
                  ? selectedContentType.name
                  : 'Select Content Type'
              }}</span>
              <i class="fas fa-caret-down"></i>
            </button>
            <div
              class="fas fa-exclamation-circle text-danger small-left-buffer"
              *ngIf="
                selectedContentType &&
                !contentTypeIsAllowed(selectedContentType.id)
              "></div>
            <div
              class="editable-field-remove"
              *ngIf="
                selectedContentType &&
                !contentTypeIsAllowed(selectedContentType.id)
              "></div>
          </div>
          <div
            *dropdownMenu
            class="small-left-buffer dropdown-menu"
            role="menu">
            <a
              class="dropdown-item"
              *ngFor="let contentType of allContentTypes"
              (click)="changeContentType(contentType.id)"
              >{{ contentType.name }}</a
            >
            <a
              class="dropdown-item"
              href="https://help.verblio.com/quick-guide-to-verblio/how-to-specify-content-types"
              target="_blank"
              >Looking for another type?
              <i
                class="tiny-left-buffer fas fa-question-circle text-secondary"></i
            ></a>
          </div>
        </div>
      </div>
      <div class="col-sm-4" *ngIf="wordCountsEnabled">
        <!-- WORD LENGTH DROPDOWN START -->
        <multipass-word-length-dropdown
          [selectedContent]="selectedProduct"
          [contents]="priceList.products"
          (selectedContentOutput)="changeProduct($event?.id, true)"
          #wordLengthDropdown>
        </multipass-word-length-dropdown>
        <!-- WORD LENGTH DROPDOWN END -->
      </div>
      <div class="col-sm-1 offset-sm-3 d-flex justify-content-end">
        <div dropdown class="btn-group">
          <button class="tiny-left-buffer btn btn-link" dropdownToggle>
            <div class="fas fa-ellipsis-v cursor-pointer text-gray"></div>
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-menu-right">
            <a
              role="menuitem"
              class="dropdown-item"
              href="{{ linkTo('improve_submissions') }}"
              target="_blank">
              Improve Submissions
              <i class="fas fa-question-circle tiny-left-buffer"></i>
            </a>
            <a
              *ngIf="viewingKeyword()"
              role="menuitem"
              class="dropdown-item cursor-pointer"
              (click)="onStartDuplication()">
              Duplicate
            </a>
            <a
              *ngIf="keyword && keyword.state != 'deleted'"
              role="menuitem"
              class="dropdown-item cursor-pointer"
              (click)="onDelete()">
              Delete Request
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="keyword?.queuedCount">
      <div class="col-8">
        <em class="float-right text-muted small">
          *Please, accept or decline your queued submissions if you want to
          change the word length
        </em>
      </div>
    </div>
    <!-- COMPONENT HEADER END -->

    <!-- EDITOR COLUMN LEFT START -->
    <!-- TITLE INPUT START -->
    <div class="row">
      <div class="col-8">
        <div
          class="order-sm-first d-flex flex-column top-buffer no-top-buffer-md mt-2 mb-3">
          <input
            placeholder="Your Title"
            formControlName="phrase"
            class="form-control keyword-phrase-input"
            data-ls-enabled
            />
        </div>
      </div>
    </div>
    <!-- TITLE INPUT END -->

    <div class="row">
      <div class="col-sm-8">
        <!-- TINYMCE EDITOR START -->
        <div class="row">
          <div class="col-12">
            <editor
              #editorEl
              (onFocus)="populatePlaceholderTemplate(true)"
              (onBlur)="populatePlaceholderTemplate(false)"
              [ngModel]="form.value.description"
              (ngModelChange)="updateDescription($event)"
              [ngModelOptions]="{ standalone: true }"
              name="description"
              data-ls-enabled="true"
              [init]="tinymceConfig">
            </editor>
          </div>
        </div>
        <!-- TINYMCE EDITOR END -->

        <!-- PDF UPLOADER START -->
        <div class="row mt-3">
          <div class="col-12">
            <i class="fas fa-paperclip text-gray mt-1"></i>
            <multipass-file-manager
              [form]="form"
              [duplicateId]="duplicateId"
              [keyword]="keyword"
              [tempFiles]="tempFiles">
            </multipass-file-manager>
          </div>
        </div>
        <!-- PDF UPLOADER END -->
      </div>
      <!-- EDITOR COLUMN LEFT END -->

      <!-- OPTIONS COLUMN RIGHT START -->
      <div class="col-sm-4">
        <div class="row mt-3">
          <div class="col-12">
            <h6 class="mb-0">OVERRIDES</h6>
            <hr class="tiny-top-buffer small-bottom-buffer" />
          </div>

          <!-- REQUIRE MY EXACT TITLE START-->
          <div class="col-12 d-flex align-items-center mb-2">
            <input
              class="mb-1"
              type="checkbox"
              id="requireSameTitle"
              name="requireSameTitle"
              formControlName="requireSameTitle" />
            <label
              class="font-weight-normal small m-0 text-gray"
              for="requireSameTitle">
              Use my exact title
              <i
                class="fas fa-question-circle tiny-left-buffer"
                popover="Leave this unchecked if you want the writer to provide your title."
                triggers="mouseover:mouseout"></i>
            </label>
          </div>
          <!-- REQUIRE MY EXACT TITLE END -->

          <!-- REFRESH EXISTING CONTENT START-->
          <div class="col-12 d-flex align-items-center mb-2">
            <input
              class="mb-1"
              type="checkbox"
              id="rewrite"
              name="rewrite"
              formControlName="rewrite" />
            <label class="font-weight-normal small m-0 text-gray" for="rewrite">
              This is a Content Refresh.
              <a
                href="https://help.verblio.com/en/articles/6037967-content-refresh"
                target="_blank"
                >Required steps</a
              >
            </label>
          </div>
          <!-- REFRESH EXISTING CONTENT END-->

          <!-- ALLOW INSECURE LINKS START -->
          <div class="col-12 d-flex align-items-center mb-2">
            <input
              class="mb-1"
              type="checkbox"
              id="allowInsecureLinks"
              name="allowInsecureLinks"
              formControlName="allowInsecureLinks" />
            <label
              class="font-weight-normal small m-0 text-gray"
              for="allowInsecureLinks">
              HTTP links are allowed
              <i
                class="fas fa-question-circle tiny-left-buffer"
                popover="Writers are usually required to use secure (HTTPS) links, in response to Google's mixed content security standards"
                triggers="mouseover:mouseout"></i>
            </label>
          </div>
          <!-- ALLOW INSECURE LINKS END -->
        </div>

        <!-- SEO OPTIONS START -->
        <div class="row mt-3" *ngIf="showSeoRequirements">
          <div class="col-12">
            <h6 class="mb-0">SEO</h6>
            <hr class="tiny-top-buffer tiny-bottom-buffer" />
            <multipass-seo-requirements
              [form]="form"
              #seoRequirementsComp></multipass-seo-requirements>
          </div>
        </div>
        <!-- SEO OPTIONS END -->

        <div class="row mt-4">
          <div class="col-12">
            <h6 class="mb-0">MANAGE</h6>
            <hr class="tiny-top-buffer small-bottom-buffer" />
          </div>

          <!-- PRIORITY PICKER START -->
          <div
            class="col-12 d-flex justify-content-start"
            #pickerAnchor
            *ngIf="onePost() && !shouldShowDeadlinePicker()">
            <div
              class="d-flex align-items-center"
              [class.d-none]="form.value.deadline || deadlinePickerVisible"
              dropdown
              (isOpenChange)="priorityActive = $event"
              container="body">
              <span
                dropdownToggle
                id="priority-picker-anchor"
                class="editable-field full">
                <div class="editable-field-icon tiny-right-buffer">
                  <i class="fas fa-arrows-alt-v"></i>
                </div>
                <span class="text-info">{{
                  priorities[form.value.priority]
                }}</span>
              </span>
              <div *dropdownMenu class="dropdown-menu">
                <a
                  *ngFor="let priorityText of priorities; index as priority"
                  role="menuitem"
                  class="dropdown-item"
                  (click)="updatePriority(priority)"
                  [class.active]="form.value.priority === priority"
                  >{{ priorityText }}
                </a>
              </div>
            </div>
          </div>
          <!-- PRIORITY PICKER END -->

          <!-- DIRECT ASSIGNMENTS START -->
          <div class="col-12 mt-2" *ngIf="shouldShowDirectAssignmentsPicker()">
            <div class="d-flex align-items-center">
              <div *ngIf="onePost(); else blockedDirectAssignmentPicker">
                <multipass-direct-assignment
                  [customer]="customer"
                  [enabled]="directAssignmentsEnabled"
                  [preassignedWriter]="preassignedWriter"
                  [keyword]="keyword"
                  [selectedProduct]="selectedProduct"
                  (assignToWriter)="onAssignWriter($event)"
                  (removeAssignment)="removeAssignment()"
                  #directAssignmentComp>
                </multipass-direct-assignment>
              </div>
              <ng-template #blockedDirectAssignmentPicker>
                <div class="editable-field empty default-pointer">
                  <i
                    class="editable-field-icon fas fa-user tiny-right-buffer text-disabled"></i>
                  <span
                    class="text-disabled"
                    popover="Not available when requesting more than 1 piece"
                    triggers="mouseover:mouseout"
                    >Any elite writer</span
                  >
                </div>
              </ng-template>
            </div>
          </div>
          <!-- DIRECT ASSIGNMENTS END -->

          <!-- DEADLINE PICKER START -->
          <div class="col-12 mt-2" *ngIf="shouldShowDeadlinePicker()">
            <div *ngIf="onePost(); else blockedDeadlinePicker">
              <multipass-deadline
                [form]="form"
                [keyword]="keyword"
                [minDeadlineDate]="minDeadlineDate"
                [maxDeadlineDate]="maxDeadlineDate"
                (closeDeadlineDialog)="closeDeadlineDialog()"
                #deadlineComp></multipass-deadline>
            </div>
            <ng-template #blockedDeadlinePicker>
              <div class="editable-field empty default-pointer">
                <i
                  class="editable-field-icon fas fa-calendar tiny-right-buffer text-disabled"></i>
                <span
                  class="text-disabled"
                  popover="Not available when requesting more than 1 piece"
                  triggers="mouseover:mouseout"
                  >Flexible timing</span
                >
              </div>
            </ng-template>
          </div>

          <div
            class="col-12"
            *ngIf="directAssignmentsEnabled && assignedWithoutDeadline">
            <div class="alert alert-danger small">
              <b>A deadline is required</b> to assign one of your preferred
              writers
            </div>
          </div>
          <!-- DEADLINE PICKER END -->
        </div>

        <div class="row mt-4">
          <!-- PRO SERVICES START -->
          <div class="col-12">
            <h6 class="mb-0">PRO SERVICES</h6>
            <hr class="tiny-top-buffer small-bottom-buffer" />
          </div>
          <div class="col-12 d-flex align-items-center mb-2">
            <input
              type="checkbox"
              id="+OptimizeContent"
              name="+OptimizeContent"
              formControlName="optimize"
              (change)="changeAddons('optimize')" />
            <label
              class="font-weight-normal small m-0 text-gray"
              for="+OptimizeContent">
              +Optimize my content
              <i
                  *ngIf="optimizeIsDisabled"
                  class="fas fa-question-circle tiny-left-buffer"
                  popover="We're sorry but we can't Optimize your content when you have HubSpot set as your delivery option. Please go to your delivery options page and provide your email or CMS information instead."
                  triggers="mouseover:mouseout"></i>
            </label>
            <a
              *ngIf="!optimizeIsDisabled"
              href="javascript:void(0)"
              (click)="openEnhancementsModal($event, enhancementAddOn.optimize)"
              class="font-weight-normal small pl-1"
              >Huh?</a
            >
          </div>
          <div class="col-12 d-flex align-items-center mb-2">
            <input
              [attr.disabled]="photoDisabled"
              type="checkbox"
              id="+photo"
              name="+photo"
              formControlName="photo"
              (change)="changeAddons('photo')" />
            <label class="font-weight-normal small m-0 text-gray" for="+photo">
              +Photo: Hand-pick {{ getNumberOfPhotos() }}
              <span *ngIf="photoDisabled" class="highlighted">FREE!</span>
            </label>
            <a
              href="javascript:void(0)"
              (click)="openEnhancementsModal($event, enhancementAddOn.photo)"
              class="font-weight-normal small pl-1"
              >Huh?</a
            >
          </div>
          <div class="col-12 d-flex align-items-center mb-2">
            <input
              type="checkbox"
              id="+video"
              name="+video"
              formControlName="video"
              (change)="changeAddons('video')" />
            <label class="font-weight-normal small m-0 text-gray" for="+video">
              +Video: Create a teaser/summary video
            </label>
            <a
              href="javascript:void(0)"
              (click)="openEnhancementsModal($event, enhancementAddOn.video)"
              class="font-weight-normal small pl-1"
              >Huh?</a
            >
          </div>
          <!-- PRO SERVICES END -->
        </div>
      </div>
      <!-- OPTIONS COLUMN RIGHT END-->
    </div>

    <hr class="d-sm-none my-2" />

    <!-- POST LIMIT INPUT ROW START -->
    <div
      *ngIf="
        customer && !['fulfilled', 'deleted'].includes(this.keyword?.state)
      "
      class="row mt-3">
      <div class="col-12 col-lg-8 d-flex flex-row align-items-center">
        <div class="d-flex form-row align-items-center">
          <div class="d-flex flex-column ml-1 mr-4">
            <label for="quantity">
              <h6 class="mb-0">
                Pieces
                <i
                  class="fas fa-question-circle tiny-left-buffer"
                  popover="You will receive {{
                    form.value.postLimit
                  }} pieces of content."
                  triggers="mouseover:mouseout"></i>
              </h6>
            </label>
            <quantity-selector
              class="keyword-form"
              #quantitySelectorRef
              name="quantity"
              [min]="keyword?.alreadyPurchasedPosts || 1"
              [max]="99"
              [quantity]="form.value.postLimit"
              (quantityChange)="validatePiecesLimit($event)"
            ></quantity-selector>
          </div>
          <div class="d-flex flex-column">
            <label for="formGroupExampleInput"
              ><h6 class="mb-0">Requires</h6></label
            >
            <div
              dropdown
              class="flex-grow-1 btn-group"
              placement="bottom right">
              <button
                dropdownToggle
                class="btn btn-outline-muted btn-block d-flex justify-content-between align-items-center bg-white">
                <span *ngIf="!selectedPaymentOption">
                  <i class="fa fa-exclamation-circle text-danger mr-1"></i>
                  make a selection
                </span>
                <span *ngIf="selectedPaymentOption">{{
                  selectedPaymentOption.optionPlaceholder
                }}</span>
                <i class="fas fa-caret-down ml-2"></i>
              </button>
              <div *dropdownMenu class="dropdown-menu mb-3" role="menu">
                <a
                  *ngFor="let option of paymentOptions"
                  [class.disabled]="option.optionDisabled"
                  (click)="selectPaymentOption(option.optionType)"
                  class="dropdown-item cursor-pointer">
                  <strong>{{ option.optionText }}</strong
                  ><br />
                  <small>
                    <i
                      *ngIf="option.optionType === 'charge'"
                      class="{{ paymentIcon() }}">
                    </i>
                    {{ option.optionDescription }}
                  </small>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- POST LIMIT INPUT ROW END -->

    <div class="row top-buffer" *ngIf="keyword?.postedCount > 0">
      <div class="col-12">
        You have already accepted {{ keyword.postedCount }} of the
        {{ form.value.postLimit }} pieces needed for this request.
      </div>
    </div>

    <!-- COMPONENT FOOTER (BUTTONS & MSGs) START -->
    <div class="row top-buffer">
      <div class="col-12" *ngIf="isEditable(); else startDuplication">
        <button
          (click)="onSaveDraft()"
          class="btn btn-outline-primary btn-block-sm-down"
          id="save-draft-btn"
          [disabled]="saveDisabled || submitting">
          {{ draftButtonText }}
        </button>
        <button
          id="activate-keyword-btn"
          (click)="onSubmit()"
          class="btn btn-primary mt-2 mt-md-0 ml-md-2 btn-block-sm-down"
          [disabled]="activationDisabled || submitting">
          <span
            *ngIf="
              !keyword || keyword?.state == 'paused' || duplicateId;
              else updating
            "
            >Activate Request</span
          >
          <ng-template #updating>
            <span *ngIf="reactivatingKeyword()">Reactivate Request</span>
            <span *ngIf="updatingCurrentKeyword()">Update Request</span>
          </ng-template>
        </button>
        <button
          (click)="onCancel()"
          class="d-none d-md-block float-right btn btn-link no-decoration">
          Cancel
        </button>
      </div>
      <ng-template #startDuplication>
        <div class="col-12">
          <button
            class="btn btn-outline-primary btn-block-sm-down"
            id="save-as-new-btn"
            (click)="onStartDuplication()">
            Duplicate
          </button>
          <button
            (click)="onCancel()"
            class="d-none d-md-block float-right btn btn-link no-decoration">
            Cancel
          </button>
        </div>
      </ng-template>
      <div class="col-12" *ngIf="hasClaimedFulfilledKeyword">
        <span class="text-gray small"
          >A writer has already fulfilled this deadline. Please create a new
          request.</span
        >
      </div>

      <div
        class="col top-buffer"
        *ngIf="
          selectedContentType && contentTypeIsAllowed(selectedContentType.id);
          else contentTypeWarning
        ">
        <hr class="tiny-top-buffer tiny-bottom-buffer" />
        <span class="text-gray small">
          {{ draftHelperText }}
        </span>
      </div>
      <ng-template #contentTypeWarning>
        <div *ngIf="contentTypesEnabled">
          <div class="col top-buffer">
            <hr class="tiny-top-buffer tiny-bottom-buffer" />
            <div
              class="fas fa-exclamation-circle text-danger small-right-buffer"></div>
            <span class="text-gray small">
              This request can not be activated at your current word-length.
              Choose a compatible content type or upgrade your subscription.
            </span>
          </div>
        </div>
      </ng-template>

      <div
        class="d-block d-md-none col d-flex flex-row justify-content-end align-items-end">
        <button
          (click)="onCancel()"
          class="float-right btn btn-link no-decoration">
          Cancel
        </button>
      </div>
    </div>
    <!-- COMPONENT FOOTER END -->
  </div>
</form>
